<template>
  <!-- style="width:385px;height:267px" -->
  <div class="flex_div">
    <div class="middle_top">
      <i>劳资统计</i>
      <!-- <span class="checkWork">考勤明细</span> -->
      <div class="flex_bet text-center" style="height:60px">
        <div
          style="
            width: 30%;
           
            padding: 4px 0px;
          "
          v-for="(item, index) in getAttendanceStatisticsData"
           :style="{background:index=='2'?'linear-gradient(180deg,rgba(255,98,99,0.8), #ff3c3c)':'linear-gradient(180deg,#1c3667, #325ba6)',width: '30%',padding: '4px 0px;'}"
          :key="index"
        >
          <p><span class="digital">{{ item.value }}</span> 人</p>
          <p :style="{color:index!='2'?'#93BBF3':'#fff', fontSize: '14px'}">{{ item.name }}</p>
        </div>
        <!-- <div style="width:30%;background:rgb(63, 114, 186,0.2);padding:4px 0px">
          <p style="color:#3D7FFF;font-size:16px;">343人</p>
          <p style="color:#fff;font-size:14px;">实际出勤数</p>
        </div>
        <div style="width:35%;background: rgb(255, 60, 60,0.4);padding:4px 0px">
          <p style="color:#fff;font-size:16px;">3人</p>
          <p style="color:#fff;font-size:14px">疫情体温异常</p>
        </div> -->
      </div>
      <!-- <p class="m-top" style="text-align: right">
        <span
          style="color: #fff; font-size: 15px; font-weight: bold;
    display: inline-block;
    text-align: left"
          >实发劳资金额：</span
        >
        <span style="font-weight: bold; color: #3d7fff; font-size: 15px;width: 110px;
            display: inline-block;"
          >{{ SalaryData.payNetAmount }}元</span
        >
      </p>
      <p style="text-align: right">
        <span
          style="
            font-weight: bold;
            color: #fff;
            font-size: 15px;
         
            display: inline-block;
            text-align: left;
          "
          >应发劳资金额：</span
        >
        <span style="font-weight: bold; color: #ff833c; font-size: 15px;  width: 110px;
            display: inline-block;"
          >{{ SalaryData.payGrossAmount }}元</span
        >
      </p> -->
      <div class="flex_bet m-top" style="height: 50%">
        <div id="chart06" style="height: 100%; width: 49.5%"></div>
        <div id="chart07" style="height: 100%; width: 49.5%"></div>
      </div>
    </div>
  </div>
</template>
<script>
import "./css/home.scss";
export default {
  data() {
    return {
      getAttendanceStatisticsData: [],
      SalaryData: {},
    };
  },
  mounted() {
    this.chart06();
    this.chart07();
  },
  methods: {
    chart06() {
      let this_ = this;
      let myChart = this_.$echarts.init(document.getElementById("chart06"));

      let option = {
        // tooltip: {
        //   trigger: "item",
        //   formatter: "{a} <br/>{b}: {c} ({d}%)",
        // },
        color: ["#5050FF", "#5E5E5E"],
        title: {
          text: "80%",
          left: "center",
          top: "52%",
          textStyle: {
            color: "#fff",
            fontSize: 14,
            align: "center",
          },
        },
        graphic: {
          type: "text",
          left: "center",
          top: "40%",
          style: {
            text: "劳资金额进度",
            textAlign: "center",
            fill: "#fff",
            fontSize: 14,
            fontWeight: 500,
          },
        },
        series: [ 
          {
            name: "运动情况",
            type: "pie",
            radius: ["75%", "85%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
            },

            data: [
              { value: 40, name: "已完成" },
              { value: 50, name: "未完成" },
            ],
          },
        ],
      };
      myChart.setOption(option);

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    chart07() {
      let this_ = this;
      let myChart = this_.$echarts.init(document.getElementById("chart07"));

      let option = {
        // tooltip: {
        //   trigger: "item",
        //   formatter: "{a} <br/>{b}: {c} ({d}%)",
        // },
        color: ["#27D9C8", "#5E5E5E"],
        title: {
          text: "85%",
          left: "center",
          top: "52%",
          textStyle: {
            color: "#fff",
            fontSize: 14,
            align: "center",
          },
        },
        graphic: {
          type: "text",
          left: "center",
          top: "40%",
          style: {
            text: "劳资人员进度",
            textAlign: "center",
            fill: "#fff",
            fontSize: 14,
            fontWeight: 500,
          },
        },
        series: [
          {
            name: "运动情况",
            type: "pie",
            radius: ["75%", "85%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
            },

            data: [
              { value: 80, name: "已完成" },
              { value: 20, name: "未完成" },
            ],
          },
        ],
      };
      myChart.setOption(option);

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    // 工资
    companyPaySalaryTotal() {
      this.$api.companyPaySalaryTotal().then((res) => {
        if (res.code == "200") {
          console.log("数据",res.data);
          this.SalaryData = res.data ? res.data : {};
        }
      });
    },
    //劳资统计-人员出勤统计
    getAttendanceStatistics() {
      this.$api.getAttendanceStatistics().then((res) => {
        if (res.code == "200") {
          console.log("出勤人数统计",res.data);
          this.getAttendanceStatisticsData = res.data;
        }
      });
    },
  },
  created() {
    //劳资统计-人员出勤统计
    this.getAttendanceStatistics();
    this.companyPaySalaryTotal();
  },
};
</script>
<style lang="scss" scoped>
.flex_div {
  width: 50%;
  height: 33%;
}
.digital {
  font-family: digital;
  font-size: 20px;
  font-style: normal;
   font-weight: 800;
}
</style>

